import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomainService } from '@shared/services';
import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/tr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  isLoading = false;
  domain: any | null = null;
  domainName: any | null = null;
  transactionInfo = JSON.parse(localStorage.getItem('transaction'));
  language = localStorage.getItem('language');

  on: any | null = null;
  constructor(
    private domainService: DomainService,
    private translate: TranslateService,
  ) {
    registerLocaleData(locale, 'tr');
  }

  ngOnInit(): void {
    this.domain = this.domainService.get;
    this.domainName = this.domain.domain.split('.')[0];
  }

  get logoUrl(): string {
    return (
      this.transactionInfo?.logoUrl ||
      `assets/img/domain/logo/${this.domain.logo}`
    );
  }
}
